/* eslint-disable */
var Translator = require('@spotahome/soyuz-trans/client');
var Experiments = require('@spotahome/soyuz-experiments/client');
var renderInDocument = require('./dist/client/common/renders/render-in-document')
  .default;
var renderInDocumentWithRouter = require('./dist/client/common/renders/render-in-document-with-router')
  .default;

var SoyuzProvider = require('./dist/client/common/context/SoyuzProvider')
  .default;
var SoyuzContext = require('./dist/client/common/context/SoyuzContext')
  .default;
var ContextWrapper = require('./dist/client/common/context/ContextWrapper').default;

var Routator = require('./dist/client/common/lib/routator');

var compose = require('./dist/client/common/lib/compose').default;
var withLocales = require('./dist/client/common/context/withLocales').default;
var withUser = require('./dist/client/common/context/withUser').default;
var withClientConfig = require('./dist/client/common/context/withClientConfig')
  .default;
var ErrorBoundary = require('./dist/client/common/components/ErrorBoundary.js')
  .default;
var Router = require('./dist/client/common/components/Router.js').default;

var getResourcePath = require('./dist/common/utils/get-resource-path')
  .default;

var clientErrorTracker = require('./dist/client/common/error-tracking/client-error-tracker').default;

module.exports = {
  renderInDocument: renderInDocument,
  renderInDocumentWithRouter: renderInDocumentWithRouter,

  SoyuzProvider: SoyuzProvider,
  ContextWrapper: ContextWrapper,
  SoyuzContextProvider: SoyuzContext.SoyuzContextProvider,
  SoyuzContextConsumer: SoyuzContext.SoyuzContextConsumer,
  useSoyuzContext: SoyuzContext.useSoyuzContext,
  useSoyuzClientConfig: SoyuzContext.useSoyuzClientConfig,
  useSoyuzLocales: SoyuzContext.useSoyuzLocales,
  useSoyuzUser: SoyuzContext.useSoyuzUser,
  useSoyuzServer: SoyuzContext.useSoyuzServer,
  useSoyuzTranslations: SoyuzContext.useSoyuzTranslations,
  useSoyuzRequest: SoyuzContext.useSoyuzRequest,
  useSoyuzData: SoyuzContext.useSoyuzData,
  useSoyuzEnv: SoyuzContext.useSoyuzEnv,
  useSoyuzBrandConfig: SoyuzContext.useSoyuzBrandConfig,
  useSoyuzFeatureToggle: SoyuzContext.useSoyuzFeatureToggle,

  trans: Translator.trans,
  getPagePath: Routator.getPagePath,
  getResourcePath: getResourcePath,
  clientErrorTracker: clientErrorTracker,

  compose: compose,
  withLocales: withLocales,
  withUser: withUser,
  withClientConfig: withClientConfig,
  ErrorBoundary: ErrorBoundary,
  Router: Router,
  SoyuzExperiment: Experiments.SoyuzExperiment,
  useSoyuzExperiment: Experiments.useSoyuzExperiment,
  SoyuzFlag: Experiments.SoyuzFlag,
  useSoyuzFlag: Experiments.useSoyuzFlag
};
